<mat-form-field appearance="outline" class="no-subscript">
  <mat-label>Next Step</mat-label>
  <input
    class="small"
    [disabled]="disabled"
    type="text"
    placeholder="Select Type"
    [(ngModel)]="step"
    matInput
    [matAutocomplete]="autoStep"
    (keyup)="changedStep($event)"
    #triggerType="matAutocompleteTrigger"
  />
  <mat-autocomplete
    #autoStep="matAutocomplete"
    #typeAutocomplete
    [displayWith]="displayStep"
    (optionSelected)="selectedStep($event)"
  >
    <mat-option class="small" *ngFor="let s of stepsFiltered" [value]="s">
      {{
        s.wfSectionConfig.number +
          " - " +
          s.wfSectionConfig.name +
          ": " +
          s.name
      }}
    </mat-option>
  </mat-autocomplete>
  <mat-error>You must choose a Step</mat-error>
  <mat-icon
    class="red pointer"
    matSuffix
    (click)="clean()"
    *ngIf="step && !disabled"
    >close</mat-icon
  >
</mat-form-field>
